import {get} from "../utils/http"


export const getJaaSToken = async () => {
	const [{
		"Registrant ID": id,
		"First & Last Name": name,
		"Email Address": email,
		"Please make it more personal by uploading a head and shoulders photo:": avatar,
	}] = window.dataLayer
	const response = await get(
		"https://47314.swoogo-retrofit.tkevents.io/rt/getToken",
		{avatar, email, id, name},
	)

	if (!response.token) {
		throw response
	} else {
		return response.token
	}
}